var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"prominent":"","type":"error"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.description))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }